"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactQuery = require("react-query");
var _revisions = _interopRequireDefault(require("./revisions"));
var queryClient = new _reactQuery.QueryClient();
var App = function App(props) {
  return /*#__PURE__*/_react.default.createElement(_reactQuery.QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/_react.default.createElement(_revisions.default, props));
};
var _default = exports.default = App;
